/**
 * @module  experience/shop/shared-browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnDestroy, OnInit, Input, OnChanges } from '@angular/core';
import { PricingOptions } from '@support/api/common/product.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';
import { SYMBOL_CONSTANTS } from '@support/shared/constants/device.constants';

@Component({
  selector: 'tmo-devices-pricing-panel',
  templateUrl: 'device-pricing-panel.component.html',
})
export class DevicePricingPanelComponent implements OnInit, OnDestroy, OnChanges {
  /**
   * Stores device amount
   */
  @Input() public deviceAmount: number;
  /**
   * Stores boolean for compare
   */
  @Input() public isCompare: boolean;
  /**
   * Stores selected eip amount
   */
  @Input() public selectedEipAmount: number;
  /**
   * Stores boolean for browse accessory
   */
  @Input() public isBrowseAccessory: boolean;
  /**
   * Stores boolean for browse accessory
   */
  @Input() public isBrowseDevice: boolean;
  /**
   * Stores formated strike through price value
   */
  @Input() public aemContent: ConfigData;
  /**
   * Stores unique id
   */
  @Input() public id: string;
  /**
   * Stores and sets minimum and maximum epin price
   */
  @Input() public set pricingOptions(pricingOptions: PricingOptions[]) {
    if (pricingOptions && pricingOptions.length > 0) {
      this.minEpinPrice = this.objectService.get(pricingOptions, '0.skuPrice');
      const lastIdx = pricingOptions.length - 1;
      this.maxEpinPrice = this.objectService.get(
        pricingOptions,
        lastIdx.toString().concat('.skuPrice')
      );
    }
  }
  /**
   * Stores true for EPIN flow
   */
  @Input() public isEpin: boolean;
  /**
   * Stores minimum epin price
   */
  public minEpinPrice: number;
  /**
   * Stores maximum epin price
   */
  public maxEpinPrice: number;
  /**
   * Stores monthly whole number price for device
   */
  public monthlyWholeNumber: string;
  /**
   * Stores monthly decimal number price for device
   */
  public monthlyDecimalNumber: string;
  /**
   * Stores minimum whole number price for epin
   */
  public minEpinWholeNumber: string;
  /**
   * Stores minimum decimal number price for epin
   */
  public minEpinDecimalNumber: string;
  /**
   * Stores maximum whole number price for epin
   */
  public maxEpinWholeNumber: string;
  /**
   * Stores maximum decimal number price for epin
   */
  public maxEpinDecimalNumber: string;
  /**
   * Stores price for compare device
   */
  public pricingForCompareDevice: boolean;
  /**
   * Stores boolean for accessories carousel
   */
  public isAccessoriesCarousel: boolean;
  /**
   * Stores disclaimerfor without service price
   */
  public withoutServicePriceDisclaimer: boolean;
  /**
   * Stores symbol for currency
   */
  public currency: string;
  /**
   * Stores symbol for hyphen
   */
  public hyphen: string;

  constructor(private objectService: ObjectService) {
    this.pricingForCompareDevice = false;
    this.isAccessoriesCarousel = false;
    this.withoutServicePriceDisclaimer = false;
  }
  /**
   * Component Init.
   *
   * @memberof EipPriceComponent
   */
  public ngOnInit(): void {
    this.currency = SYMBOL_CONSTANTS.DOLLAR;
    this.hyphen = SYMBOL_CONSTANTS.HYPHEN;
    this.splitPrice();
    this.splitEpinPrice();
  }

  /**
   * Method to split price for device
   */
  public splitPrice(): void {
    const numberOfDecimalDigits = 2;
    if (this.deviceAmount) {
      const tempNumber = this.deviceAmount.toFixed(numberOfDecimalDigits);
      this.monthlyWholeNumber = tempNumber.split('.')[0];
      if (!this.isBrowseAccessory && this.isEpin) {
        this.monthlyDecimalNumber = tempNumber.split('.')[1].concat(SYMBOL_CONSTANTS.ASTERIX);
      } else {
        this.monthlyDecimalNumber = tempNumber.split('.')[1];
      }
    } else {
      this.monthlyWholeNumber = this.monthlyDecimalNumber = '00';
    }
  }

  /**
   * Method to store minimum and maximum price for epin
   */
  public splitEpinPrice(): void {
    const numberOfDecimalDigits = 2;
    if (this.minEpinPrice && this.maxEpinPrice) {
      const tempMinNumber = this.minEpinPrice.toFixed(numberOfDecimalDigits);
      const tempMaxNumber = this.maxEpinPrice.toFixed(numberOfDecimalDigits);
      this.minEpinWholeNumber = tempMinNumber.split('.')[0];
      this.minEpinDecimalNumber = tempMinNumber.split('.')[1];
      this.maxEpinWholeNumber = tempMaxNumber.split('.')[0];
      if (this.isBrowseAccessory) {
        this.maxEpinDecimalNumber = tempMaxNumber.split('.')[1];
      } else {
        this.maxEpinDecimalNumber = tempMaxNumber.split('.')[1].concat(SYMBOL_CONSTANTS.ASTERIX);
      }
    } else {
      this.minEpinWholeNumber = this.minEpinDecimalNumber = '00';
      this.maxEpinWholeNumber = this.maxEpinDecimalNumber = '00';
    }
  }

  /**
   * Method to split prices
   */
  public ngOnChanges(): void {
    this.splitPrice();
  }

  /**
   * Component Clean-up
   * @memberof EipPriceComponent
   */
  public ngOnDestroy(): void {}
}
